module.exports = __webpack_public_path__ + "img/img4.599bf4d0.png";